import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _objectWithoutProperties from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/objectWithoutProperties.js";
var _excluded = ["projects", "account", "avatar", "groups"],
    _excluded2 = ["projects"],
    _excluded3 = ["projects"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import EntityPicker from 'src/components/Pickers/Picker';
import User from 'src/store/models/User';
import { dialog } from 'src/boot/mixins.js';
import { orderBy } from 'lodash';
import WorkspaceAccessLevel from 'src/components/Pickers/WorkspaceAccessLevel';
import WorkingHours from 'src/components/WorkingHours';
import WorkingHoursReminder from 'src/components/WorkingHoursReminder';
import SubscriptionTypeUpgrade from 'src/components/SubscriptionTypeUpgrade';
import moment from 'moment';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog,
    EntityPicker: EntityPicker,
    WorkspaceAccessLevel: WorkspaceAccessLevel,
    WorkingHours: WorkingHours,
    WorkingHoursReminder: WorkingHoursReminder,
    SubscriptionTypeUpgrade: SubscriptionTypeUpgrade
  },
  props: ['user-id'],
  data: function data() {
    return {
      tab: 'info',
      isDirty: false,
      hourlyRateHover: false,
      hourlyCostHover: false,
      managerHover: false,
      myUser: {
        is_gm: 0,
        projects: [],
        settings: {
          reminderEmail: {
            timeOfDay: '17:00',
            percentageThreshold: 80,
            cadence: 'weekly',
            dayOfWeek: 5,
            enabled: false
          }
        }
      },
      loading: false
    };
  },
  watch: {
    myUser: {
      deep: true,
      handler: function handler(val, oldVal) {
        if (!this.isDirty && oldVal) {
          this.isDirty = true;
        }
      }
    }
  },
  computed: {
    user: function user() {
      return User.query().with(['avatar', 'groups']).find(this.userId);
    },
    disableRolePicker: function disableRolePicker() {
      return this.myUser.user_id === this.me.user_id || !this.me.is_admin || this.myUser.is_owner && !this.me.is_owner;
    },
    workingHours: {
      get: function get() {
        return User.getWorkingDays(this.myUser);
      },
      set: function set(val) {
        this.myUser.working_hours = val;
      }
    },
    reminderEmail: {
      get: function get() {
        var reminderEmail = this.myUser.settings.reminderEmail;

        if (reminderEmail.enabled === null && this.me.account.settings.reminderEmail) {
          reminderEmail = this.me.account.settings.reminderEmail;
        }

        return reminderEmail;
      },
      set: function set(val) {
        this.myUser.settings.reminderEmail = val;
      }
    },
    sessionLastTime: function sessionLastTime() {
      return this.user && this.user.session_last_time ? moment(this.user.session_last_time).fromNow() : this.$t('components.userDialog.never_logged_in');
    },
    formattedSessionLastTime: function formattedSessionLastTime() {
      // Use browser default locale to format the date
      // Also, use the the browser's timezone
      return this.user && this.user.session_last_time ? moment(this.user.session_last_time).format('LLLL') : '';
    }
  },
  methods: {
    save: function save() {
      var _this = this;

      this.showLoading(); // Create an object that has only the changed values from the original user

      var userData = {};

      for (var key in function (_ref) {
        var projects = _ref.projects,
            account = _ref.account,
            avatar = _ref.avatar,
            groups = _ref.groups,
            o = _objectWithoutProperties(_ref, _excluded);

        return o;
      }(this.myUser)) {
        if (this.myUser[key] !== this.user[key]) {
          userData[key] = this.myUser[key];
        }
      }

      userData.projects = this.myUser.projects.filter(function (project) {
        return project.delete || project.new || project.changed;
      }).map(function (project) {
        var data = {
          project_id: project.project_id,
          pivot: {
            is_pm: project.pivot.is_pm
          }
        };

        if (project.delete) {
          data.delete = 1;
        }

        if (project.new) {
          data.new = 1;
        }

        if (project.changed) {
          data.changed = 1;
        }

        return data;
      });

      if (userData.projects.length === 0) {
        delete userData.projects;
      }

      User.api().put('/users/' + this.userId, userData, {
        save: false
      }).then(function (_ref2) {
        var response = _ref2.response;

        _this.$root.$emit('refresh-users');

        _this.$root.$emit('refresh-business-hours');

        _this.myUser = response.data;
        _this.myUser.projects = response.data.projects.map(function (project) {
          var group = project.groups.find(function (g) {
            return g.group_id === _this.myUser.group_id;
          });
          return _objectSpread(_objectSpread({}, project), {}, {
            group: group
          });
        });

        var userProperties = function (_ref3) {
          var projects = _ref3.projects,
              o = _objectWithoutProperties(_ref3, _excluded2);

          return o;
        }(_this.myUser);

        User.insertOrUpdate({
          data: userProperties
        });

        _this.$q.notify({
          message: _this.$t('general.has_been_updated', {
            el: _this.myUser.name
          }),
          type: 'positive'
        });

        _this.$nextTick(function () {
          _this.isDirty = false;
        });
      }).catch(function () {}).finally(function () {
        _this.hideLoading();
      });
    },
    markForDeletion: function markForDeletion(project, index) {
      if (!project.new) {
        this.$set(project, 'delete', true);
      } else {
        this.myUser.projects.splice(index, 1);
      }
    },
    undoDeletion: function undoDeletion(project, index) {
      this.$set(project, 'delete', false);
    },
    setAsChanged: function setAsChanged(project, index, val) {
      if (!project.new) {
        project.changed = true;
      }
    },
    addProjects: function addProjects(projects) {
      this.myUser.projects = orderBy([].concat(_toConsumableArray(this.myUser.projects), _toConsumableArray(this.normalizeProjects(projects))), [function (user) {
        return user.name.toLowerCase();
      }], ['name', 'asc']);
    },
    deactivateUser: function deactivateUser() {
      var _this2 = this;

      this.showLoading();
      User.$deactivate([this.myUser]).then(function () {
        _this2.hideLoading();

        _this2.$q.notify({
          message: _this2.$t('general.user_deactivated'),
          type: 'positive'
        });

        _this2.$root.$emit('refresh-users');

        _this2.hide();
      }).catch(function () {
        _this2.hideLoading();

        _this2.$q.notify({
          message: _this2.$t('components.dialogs.error_deactiving_user'),
          type: 'negative'
        });
      });
    },
    activateUser: function activateUser() {
      var _this3 = this;

      this.showLoading();
      User.$activate([this.myUser]).then(function () {
        _this3.$q.notify({
          message: _this3.$t('components.userDialog.user_activated'),
          type: 'positive'
        });

        _this3.$root.$emit('refresh-users');

        _this3.hide();
      }).catch(function () {}).finally(function () {
        _this3.hideLoading();
      });
    },
    showDeleteDialog: function showDeleteDialog() {
      this.openDialog('UserDeleteDialog', {
        selectedUsers: [{
          name: this.myUser.name
        }],
        onDelete: this.deleteUser
      });
    },
    showActivationDialog: function showActivationDialog(archiving) {
      this.openDialog('UserActivationDialog', {
        archiving: archiving,
        selectedUsers: [{
          name: this.myUser.name
        }],
        onConfirm: archiving ? this.deactivateUser : this.activateUser
      });
    },
    deleteUser: function deleteUser() {
      var _this4 = this;

      this.showLoading();
      User.$delete(this.myUser.user_id).then(function () {
        _this4.hideLoading();

        _this4.$q.notify({
          message: _this4.$t('components.userDialog.deleted_user'),
          type: 'positive'
        });

        _this4.$root.$emit('refresh-users');

        _this4.hide();
      }).catch(function () {
        _this4.hideLoading();

        _this4.$q.notify({
          message: _this4.$t('components.userDialog.error_deleting_user'),
          type: 'negative'
        });
      });
    },
    normalizeProjects: function normalizeProjects(projects) {
      return projects.map(function (project) {
        project.pivot = project.pivot ? project.pivot : {
          is_pm: 0
        };
        project.new = true;
        return project;
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.loading = true;
    User.api().get('/users/' + this.userId, {
      save: false
    }).then(function (_ref4) {
      var response = _ref4.response;
      _this5.myUser = response.data;
      _this5.myUser.projects = response.data.projects.map(function (project) {
        var group = project.groups.find(function (g) {
          return g.group_id === _this5.myUser.group_id;
        });
        return _objectSpread(_objectSpread({}, project), {}, {
          group: group
        });
      });

      var userProperties = function (_ref5) {
        var projects = _ref5.projects,
            o = _objectWithoutProperties(_ref5, _excluded3);

        return o;
      }(_this5.myUser);

      User.insertOrUpdate({
        data: userProperties
      });

      _this5.$nextTick(function () {
        _this5.isDirty = false;
      });
    }).catch(function (e) {
      console.error(e);
    }).finally(function () {
      _this5.loading = false;
    });
  }
};